<template>
  <div id="invitation" class="px-4 mt-4 pb-3">
    <div class="row">
      <div class="col-xl-5">
        <div class="cotizarlo-general-wrapper">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <h3 class="subtitle-section">
                  Invitación recibida
                  <i class="fa fa-info-circle ml-1" aria-hidden="true"></i>
                </h3>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                Enhorabuena has recibido una invitación para unirte al equipo de <strong>{{teamOwner.user.name}} {{teamOwner.user.last_name}}</strong>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <p class="plan-description">
                  Al unirte ha este equipo recibiras los beneficios que están relacionados con dicho equipo.
                </p>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <p>
                  Te recordamos que una vez que aceptes la invitación a ser miembro de un equipo, todas las cotizaciones que tengas al momento estarán de dejar disponibles
                </p>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-8 offset-2">
                <button type="button" class="btn btn-simple btn-sm text-uppercase form-control" @click="userAcceptInvitation()">
                  Aceptar invitación
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import clientService from "@/api/clients";
export default {
  beforeMount() {
    this.inviteToken = this.$route.query.token;
    this.getTokenInformation()
  },
  data(){
    return{
      teamOwner:{
        user:{
          name:"",
          last_name:"",
        }
      },
      userData:{},
      inviteToken:""
    }
  },
  methods:{
    getTokenInformation(){
      let data = {
        token: this.inviteToken,
      };
      clientService.getInvitationInformation(data).then((response) => {
        this.userData = response.data.data.user;
        this.teamOwner = response.data.data.team;
      })
      .catch(() => {
        this.$router.push({
          name: "clientDashboard",
        });
      });
    },
    userAcceptInvitation(){
      this.$store.dispatch("showLoader", { show: true });
      let data = {
        token: this.inviteToken,
      };
      clientService.userAcceptInvitation(data).then(
        () => {
          this.$store.dispatch('client/setData').then(
            () => {
              this.$router.push({name:'clientDashboard'})
              this.$store.dispatch("showLoader", { show: false });
            }
          )
        })
        .catch(() => {
          this.$router.push({
            name: "clientDashboard",
          });
        });
    }
  }
};
</script>
